import { render, staticRenderFns } from "./buy.vue?vue&type=template&id=c9f9e894&scoped=true"
import script from "./buy.vue?vue&type=script&lang=ts"
export * from "./buy.vue?vue&type=script&lang=ts"
import style0 from "./buy.vue?vue&type=style&index=0&id=c9f9e894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f9e894",
  null
  
)

export default component.exports